<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :pagination="pagination"
      resource="after_sales"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class AftersaleAudit extends Vue {

  table = {
    data: []
  }

  pagination = {}

  columns = [
    {
      prop: 'id',
      label: '编号'
    },
    {
      prop: 'user',
      label: '操作者',
      renderCell(h, { row }) {
        const userName = _.get(row, `user.${row.user_type === 'User' ? 'nickname' : 'email'}`)
        return <span>{ userName }</span>
      }
    },
    {
      prop: 'change',
      label: '审核更改'
    },
    {
      prop: 'created_at',
      label: '创建时间',
      renderCell: 'time'
    }
  ]

  async mounted() {
    const { data, pagination } = await this.$request.get(`/after_sales/${this.$route.params.id}/audits`);
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
